export type ResponseErrorInit = {
  error: string
  statusCode: number
  message: string
  detail: string
  url: string
  title: string
  traceId: string
  type: string
}

export class ResponseError extends Error {
  public error: string
  public statusCode: number
  public detail: string
  public title: string
  public traceId: string
  public url: string
  public type: string

  public constructor({
    error,
    statusCode,
    detail,
    url,
    message,
    title,
    traceId,
    type,
  }: ResponseErrorInit) {
    super(message)
    this.name = "ResponseError"
    this.error = error
    this.statusCode = statusCode
    this.detail = detail
    this.title = title
    this.traceId = traceId
    this.url = url
    this.type = type
  }
}
